"use client";

// import { IconPlus } from "@tabler/icons-react";
import { useTranslations } from "next-intl";
import { toast } from "sonner";
import { Button } from "@/components/ui";

import "viem/window";

// type AddNftToWalletProps = {
//   contractAddress: `0x${string}`;
//   tokenId: string | number | bigint;
// };

export function AddNftToWallet() {
  const t = useTranslations("modals");
  const handleClick = async () => {
    const provider = (window as Window).ethereum;
    if (!provider) {
      toast.error(t("addNft.walletNotConnected"));
      return;
    }

    // try {
    // const wasAdded = await provider.request({
    //   method: "wallet_watchAsset",
    //   params: {
    //     type: "ERC721" as "ERC20", // or 'ERC1155'
    //     options: {
    //       address: contractAddress,
    //       // tokenId: tokenId.toString(),
    //     },
    //   },
    // });

    // if (wasAdded) {
    //   toast.success(t("addNft.addSuccess"));
    // } else {
    //   toast.error(t("addNft.userRejected"));
    // }
    // } catch (error) {
    //   toast.error(t("addNft.addError"));
    //   console.error(error);
    // }
  };

  return (
    <Button
      colors="primary"
      radius="sm"
      className="w-full mt-4"
      onClick={handleClick}
      // startIcon={<IconPlus size={20} />}
    >
      {t("addNft.addToWallet")}
    </Button>
  );
}
